import React, { Component } from 'react';
import '../css/LogoWall.css';

class LogoWall extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

        return (
          <div className="marquee">
		    <div className="marquee__group">
		    	{/*<img src="/assets/logowall_urobot.svg" />*/}
		      <img src="/logo/logowall_acer.svg" />
		      <img src="/logo/logowall_cbm.svg" />
		      <img src="/logo/logowall_chem.jpg" />
		      <img src="/logo/logowall_credit.svg" />
		      <img src="/logo/logowall_doday.svg" />
		      <img src="/logo/logowall_dodohome.png" />
		      <img src="/logo/logowall_easycard.svg" />
		      <img src="/logo/logowall_ingensys.svg" />
		      <img src="/logo/logowall_linepay.svg" />
		      <img src="/logo/logowall_miaoli.svg" />
		      <img src="/logo/logowall_nvidia.svg" />
		      <img src="/logo/logowall_taiwanbio.png" />
		      <img src="/logo/logowall_telecom.svg" />
		      <img src="/logo/logowall_ubereats.svg" />
		      <img src="/logo/logowall_ur.webp" />
		    </div>

		    <div className="marquee__group">
		    	{/*<img src="/assets/logowall_urobot.svg" />*/}
			  <img src="/logo/logowall_acer.svg" />
		      <img src="/logo/logowall_cbm.svg" />
		      <img src="/logo/logowall_chem.jpg" />
		      <img src="/logo/logowall_credit.svg" />
		      <img src="/logo/logowall_doday.svg" />
		      <img src="/logo/logowall_dodohome.png" />
		      <img src="/logo/logowall_easycard.svg" />
		      <img src="/logo/logowall_ingensys.svg" />
		      <img src="/logo/logowall_linepay.svg" />
		      <img src="/logo/logowall_miaoli.svg" />
		      <img src="/logo/logowall_nvidia.svg" />
		      <img src="/logo/logowall_taiwanbio.png" />
		      <img src="/logo/logowall_telecom.svg" />
		      <img src="/logo/logowall_ubereats.svg" />
		      <img src="/logo/logowall_ur.webp" />
		    </div>
		  </div>
        ) 
  }

}

export default LogoWall;